import React from "react";
import DonutChart from "./DonutChart";

const CreatorSizeBreakdown = ({ creators }) => {
  const tiers = { nano: 0, micro: 0, mid: 0, macro: 0, mega: 0 };

  creators.forEach((c) => {
    const subs = c.creator.subscribers || c.creator.follower_count || 0;
    if (subs >= 1000000) tiers.mega++;
    else if (subs >= 100000) tiers.macro++;
    else if (subs >= 10000) tiers.mid++;
    else if (subs >= 1000) tiers.micro++;
    else tiers.nano++;
  });

  const segments = [
    { label: 'Mega (1M+)', value: tiers.mega, color: '#8b5cf6' },
    { label: 'Macro (100K-1M)', value: tiers.macro, color: '#06b6d4' },
    { label: 'Mid (10K-100K)', value: tiers.mid, color: '#22c55e' },
    { label: 'Micro (1K-10K)', value: tiers.micro, color: '#eab308' },
    { label: 'Nano (<1K)', value: tiers.nano, color: '#f97316' },
  ].filter(s => s.value > 0);

  const total = creators.length;

  return (
    <div className="flex flex-col lg:flex-row items-center gap-6">
      <DonutChart data={segments} size={140} strokeWidth={20} />
      <div className="flex-1 space-y-2">
        {segments.map((seg, idx) => (
          <div key={idx} className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: seg.color }} />
            <span className="text-sm text-theme-text flex-1">{seg.label}</span>
            <span className="text-sm font-semibold text-theme-text">{seg.value}</span>
            <span className="text-xs text-theme-text opacity-50 w-12 text-right">
              {total > 0 ? `${((seg.value / total) * 100).toFixed(0)}%` : '0%'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreatorSizeBreakdown;
